/* eslint-disable */

(function($) {
  $(document).ready(function() {
    $('a[href*="#"]', $('body'))
      .not('[href="#"]')
      .not('[href="#0"]')
      .not('[data-toggle=tab]')
      .on('click', (e) => {
        const element = e.currentTarget;

        if (location.pathname.replace(/^\//, '') === element.pathname.replace(/^\//, '') && location.hostname === element.hostname) {
          e.preventDefault();
          const target = $(element.hash);

          $('html, body').animate({
            scrollTop: target.offset().top,
          }), 500, 'linear';
        }
    });


    $('.desktop-filter .nectar-button').on('click', function(e) {
      e.preventDefault();
      var filter = $(this).data('filter');
      
      // Handle active states
      $('.desktop-filter .nectar-button.active').removeClass('active');

      if (filter !== '*') {
        $(this).addClass('active');
      }

      filterProjects(filter);
    });

    $('.mobile-filter').on('change', function(e) {
      var filter = $(this).val();
      
      filterProjects(filter);
    });
    
    /**
     * Filter the list of projects based on the passed class, a category
     * 
     * @param {string} filterClass 
     */
    function filterProjects(filterClass) {
      let articles = $('article.category-projecten');

      
      if (filterClass === '*') {
        articles.removeClass('hidden');
      } else {
        // Hide all articles
        articles.addClass('hidden');

        // Show all articles with specified filter class
        $('article.category-' + filterClass).removeClass('hidden');
      }
    }
  });
})(jQuery)
/* eslint-enable */
